import {Component, OnInit, ViewChild,} from '@angular/core';
import {CorePopupComponent} from '../../../ui-components/core-popup/core-popup.component';
import {IServicePriceItems,} from '../../services/services/services/services.service';
import {AppMessageService} from '../../services/app-message/app-message.service';
import {UserManagementService} from "../../services/user-management/user-management.service";
import {TranslateService} from "@ngx-translate/core";
import {AuthService} from "../../services/auth/auth.service";

export interface IServicePricePopupResponse {
  services: IServicePriceItems[];
  totalPrice: number;
  numberOfService: number;
}

@Component({
  selector: 'app-password-change-popup',
  templateUrl: './password-change-popup.component.html',
})
export class PasswordChangePopupComponent implements OnInit {
  @ViewChild('popup') popup: CorePopupComponent;


  loading: boolean = false;
  openPopup: boolean = false;
  firstly: boolean = false;
  total: number = 0;
  numberOfService: number = 0;


  passwordForm = {
    oldPassword: '',
    newPassword: '',
    newPasswordConfirm: '',
    isHover1: false,
    isHover2: false,
    isHover3: false,
  };

  constructor(
    private readonly messageService: AppMessageService,
    private readonly userService: UserManagementService,
    private readonly authService: AuthService,
    private readonly translate: TranslateService
  ) {
  }

  ngOnInit() {

  }

  updatePassword() {
    this.userService
      .changePassword({
        id: this.authService.getUserId(),
        oldPassword: this.passwordForm.oldPassword,
        newPassword: this.passwordForm.newPassword,
        newPasswordConfirm: this.passwordForm.newPasswordConfirm,
      })
      .subscribe({
        next: (res) => {
          this.loading = false;
          this.messageService.successToast(
            this.translate.instant('common.success'),
            this.translate.instant(
              'settings.user-settings.change-password-success'
            )
          );
        },
        error: () => {
          this.loading = false;
        },
        complete: () => {
          this.passwordForm.oldPassword = '';
          this.passwordForm.newPassword = '';
          this.passwordForm.newPasswordConfirm = '';
          this.onPopupClosed();
          this.popup.closeDialog();
        },
      });
  }


  resetParams() {

    this.openPopup = false;
    this.total = 0;
    this.numberOfService = 0;
  }


  onPopupClosed() {
    this.resetParams();
  }

  initilize(type='first') {
    this.popup.openDialog();
    if (type=='first'){
      this.firstly=true;
    }
    this.openPopup = true;
  }
}
